import React from 'react'
import styled from 'styled-components';
import StyledText from "../../components/StyledComponents/StyledText";
import PlaceholderImage from "../../assets/images/placeholder-image.jpg";
import { Button } from "../../components/form/Button";
import { getSessionTimeLeftLabel } from "../../utils/helper";
import { useSelector } from 'react-redux';
import { selectAuth } from '../auth/authSlice';
import { logOut } from '../auth/services/auth';

const ForceLoginBar = () => {
    const auth = useSelector(selectAuth);
  return (
    <ForceLoginBarCon>
        <div className="d-flex gap-3">
            <ForceLoginUserInfo>
            <ProfileImage $src={auth?.userSignedUrl || PlaceholderImage} style={{ minWidth: '24px', width: '24px', height: '24px' }}>
                <img
                src={ auth?.userSignedUrl || PlaceholderImage}
                alt={auth?.viewerName || "L3 user"}
                onError={(e) => {
                    (e.target as HTMLImageElement).src = PlaceholderImage;
                }}
                />
            </ProfileImage>
            <StyledText
                fontSize="14px"
                fontWeight={700}
                fontFamily={"var(--brand-font)"}
                textColor="#003366"
                style={{ textDecoration: 'underline' }}
            >
                {auth?.viewerName} <span style={{ color: '#FF6D41', fontWeight: 500 }}>(L2)</span>
            </StyledText>
            <StyledText
                fontSize="14px"
                fontWeight={400}
                fontFamily={"var(--brand-font)"}
                textColor="#003366"
            >
                is impersonating as :
            </StyledText>
            <ProfileImage $src={auth?.contactSignedUrl || PlaceholderImage}  style={{ minWidth: '24px', width: '24px', height: '24px' }}>
                <img
                src={ auth?.contactSignedUrl || PlaceholderImage}
                alt={auth?.firstName + " " + auth?.lastName || "L2 user"}
                onError={(e) => {
                    (e.target as HTMLImageElement).src = PlaceholderImage;
                }}
                />
            </ProfileImage>
            <StyledText
                fontSize="14px"
                fontWeight={700}
                fontFamily={"var(--brand-font)"}
                textColor="#003366"
                style={{ textDecoration: 'underline' }}
            >
                {auth?.firstName} {auth?.lastName} <span style={{ color: '#FF6D41', fontWeight: 500 }}>(L3)</span>
            </StyledText>
            </ForceLoginUserInfo>
            <div className="d-flex align-items-center gap-2">
            <Dot />
            <StyledText
                textColor='#1E1E1E'
                fontSize='14px'
                fontWeight={400}
            >
                {/* This impersonation session will expires after {getSessionExpiryLabel(auth?.expiresIn ?? 0)} */}
                This impersonation session will expires after {getSessionTimeLeftLabel(auth?.expiresIn ?? 0)}
            </StyledText>
            </div>
        </div>
        <Button
            $variant="customButton"
            btnBg='#ffffff'
            color='#003366'
            fontSize='12px'
            onClick={() => {
                void logOut();
            }}
        >
            Logout Session
        </Button>
    </ForceLoginBarCon>
  )
}

export default ForceLoginBar

const ForceLoginBarCon = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #FFE8B7;
  padding: 0.65rem 2.5rem;
`;

const Dot = styled.span<{ size?: number; color?: string }>`
  display: inline-block;
  width: ${({ size }) => size || 8}px;
  height: ${({ size }) => size || 8}px;
  border-radius: 50%;
  background-color: ${({ color }) => color || "#003366"};
`;

const ProfileImage = styled.div<{ $src?: string }>`
  width: 24px;
    height: 24px;
    border-radius: 50%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
  
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
`;

const ForceLoginUserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.65rem;
  background-color: #ffffff;
  border-radius: 5px;
  padding: 5px 10px;
`;